import { WorkerAction, WorkerFnParams } from '../wasm-git.worker.model';
import { FSAction } from './actions.enum';
import { FSWriteFileActionFn } from './fs-write-file';
import { FSWriteJSONActionFn } from './fs-write-json';
import { FSWriteYAMLActionFn } from './fs-write-yaml';

export interface FSWriteFilesAction extends WorkerAction {
  type: FSAction.WriteFiles;
  params: { files: Array<{ path: string; propertyPath?: string[]; content?: object | string }> };
}

export async function FSWriteFilesActionFn(params: WorkerFnParams<FSWriteFilesAction>): Promise<void> {
  const { files } = params.params;

  await Promise.all(
    files.map(async ({ path, propertyPath, content }) => {
      if (
        typeof content === 'string' ||
        !['json', 'yml', 'yaml'].some((fileEnding) => path.endsWith(`.${fileEnding}`))
      ) {
        await FSWriteFileActionFn({
          ...params,
          params: {
            path,
            content: content as string,
            skipSync: true,
          },
        });
      } else if (path.endsWith('.json')) {
        await FSWriteJSONActionFn({
          ...params,
          params: {
            path,
            propertyPath,
            content,
            skipSync: true,
          },
        });
      } else {
        await FSWriteYAMLActionFn({
          ...params,
          params: {
            path,
            propertyPath,
            content,
            skipSync: true,
          },
        });
      }
    }),
  );

  await params.util.syncfs(false);
}
